const PropTypes = require('prop-types');
const React = require('react');
const LoadingOverlay = require('components/shared/loading_overlay.jsx');
const ListingPlaceholder =
  require('components/comparison_shopping_page/listing_placeholder.jsx');
const ReactUJS = require('components/react_ujs.js');

class ListingTabContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      listingData: null,
    };
  }

  componentDidMount() {
    this.fetchListingsData();
  }

  componentDidUpdate() {
    if (this.refs.content) {
      this.initReactInServerHtml();
      this.initTooltips();
    }
  }

  setListingData(data) {
    this.setState({
      loading: false,
      listingData: data,
    });
    if (this.props.listingsLoaded) {
      const listingIds = this.extractListingIds(data);
      this.props.listingsLoaded(listingIds);
    }
  }

  extractListingIds(listingHTML) {
    return $(listingHTML)
      .find('[data-product-id]')
      .map((_, el) => $(el).data('product-id'))
      .toArray();
  }

  initTooltips() {
    initTips(this.refs.content);
  }

  initReactInServerHtml() {
    ReactUJS.init(window, this.refs.content);
  }

  fetchListingsData() {
    this.markAsLoadingData();

    $.get(this.listingUrl, this.searchParams()).then((newListingData) => {
      this.setListingData(newListingData);
    });
  }

  searchParams() {
    const searchParams = this.props.searchParams || {};
    const additionalParams = {
      buy_button_listings: this.props.buyButtonListings,
    };
    return Object.assign(searchParams, additionalParams);
  }

  isLoadingData() {
    return this.state.loading;
  }

  markAsLoadingData() {
    this.setState({ loading: true });
  }

  get listingUrl() {
    const id = this.props.comparisonShoppingPageSlug;
    return `/comparison_shopping/${id}/products?condition=${this.props.listingCondition}`;
  }

  get domId() {
    return `${this.props.listingCondition}-listing-tab-content`;
  }

  renderPlaceholder() {
    return (
      <div>
        <ListingPlaceholder />
        <ListingPlaceholder />
        <ListingPlaceholder />
      </div>
    );
  }

  renderInnerContent() {
    if (this.state.listingData) {
      return (
        <div
          className={this.props.containerClass}
          id={this.domId}
          ref="content"
        >
          <div
            dangerouslySetInnerHTML={{ __html: this.state.listingData }}
          />
        </div>
      );
    }

    return this.renderPlaceholder();
  }

  render() {
    return (
      <LoadingOverlay showOverlay={this.isLoadingData()} >
        {this.renderInnerContent()}
      </LoadingOverlay>
    );
  }
}

ListingTabContent.propTypes = {
  comparisonShoppingPageSlug: PropTypes.string.isRequired,
  listingCondition: PropTypes.string.isRequired,
  scrollToTop: PropTypes.func,
  containerClass: PropTypes.string,
  searchParams: PropTypes.object,
  buyButtonListings: PropTypes.array,
  listingsLoaded: PropTypes.func,
};

module.exports = ListingTabContent;



// WEBPACK FOOTER //
// ./javascripts/components/comparison_shopping_page/listing_tab_content.jsx